import { loadEmberApp } from './ember/load-ember-app';

const ember = {
    name: '@bluedolphin/ember',
    app: () => {
        const appName = 'bluedolphin';
        const bluedolphin = System.resolve('bluedolphin/js-bluedolphin');
        const vendor = System.resolve('bluedolphin/js-vendor');
        return loadEmberApp(appName, bluedolphin, vendor);
    },
    activeWhen: [
        '/:tenantId/home',
        '/:tenantId/admin',
        '/:tenantId/dashboard',
        '/:tenantId/drafts',
        '/:tenantId/guestlink',
        '/:tenantId/objects',
        '/:tenantId/reports',
        '/:tenantId/settings/display',
        '/:tenantId/sources',
    ],
    customProps: {},
};

const navbar = {
    name: '@bluedolphin/navbar-mf',
    app: () => System.import('@bluedolphin/navbar-mf'),
    activeWhen: [
        '/:tenantId/home',
        '/:tenantId/admin',
        '/:tenantId/dashboard',
        '/:tenantId/drafts',
        '/:tenantId/guestlink',
        '/:tenantId/objects',
        '/:tenantId/reports',
        '/:tenantId/settings',
        '/:tenantId/system-preferences',
        '/:tenantId/sources',
        '/:tenantId/usage-insights',
        '/:tenantId/bpmn',
        '/:tenantId/processes',
        '/:tenantId/projects',
        '/:tenantId/repository',
        '/:tenantId/views',
    ],
    customProps: {},
};

const bpmn = {
    name: '@bluedolphin/bpmn',
    app: () => System.import('@bluedolphin/bpmn'),
    customProps: {},
    addonIdentifiers: [
        {
            identifier: 'BPMNIO',
            activeWhen: ['/:tenantId/bpmn', '/:tenantId/processes'],
        },
        {
            identifier: 'EDITOR_V2',
            activeWhen: ['/:tenantId/views'],
        },
    ],
};

const insights = {
    name: '@bluedolphin/insights',
    app: () => System.import('@bluedolphin/insights'),
    activeWhen: ['/:tenantId/usage-insights'],
    customProps: {},
};

const systemManagement = {
    name: '@bluedolphin/system-management-mf',
    app: () => System.import('@bluedolphin/system-management-mf'),
    customProps: {},
    addonIdentifiers: [
        {
            identifier: 'MARKETPLACE',
            activeWhen: ['/:tenantId/system-preferences/marketplace'],
        },
    ],
};

const solutionDesign = {
    name: '@bluedolphin/solution-design',
    app: () => System.import('@bluedolphin/solution-design'),
    customProps: {},
    addonIdentifiers: [
        {
            identifier: 'PROJECTS',
            activeWhen: ['/:tenantId/projects'],
        },
        {
            identifier: 'REPOSITORY',
            activeWhen: ['/:tenantId/repository'],
        },
    ],
};

const authMf = {
    name: '@bluedolphin/auth-mf',
    app: () => System.import('@bluedolphin/auth-mf'),
    activeWhen: ['/'],
    customProps: {
        applications: [
            navbar,
            ember,
            bpmn,
            insights,
            systemManagement,
            solutionDesign,
        ],
    },
};

export const applications = [authMf];
